export { useCommonCriteriaVersions } from './useCommonCriteriaVersions';
